/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_City_RequiredInputs */

const cs_validation_city_required = /** @type {(inputs: Validation_City_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Město je povinné`)
};

const en_validation_city_required = /** @type {(inputs: Validation_City_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City is required`)
};

/**
* | output |
* | --- |
* | "City is required" |
*
* @param {Validation_City_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_city_required = /** @type {((inputs?: Validation_City_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_City_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_city_required(inputs)
	return cs_validation_city_required(inputs)
});